// All delays in ms

const SECOND = 1000;

const DELAY = Object.freeze({
  // no delay useful only for adding a new setTimeout frame at the top of the queue
  none: 0,
  workaround: 0,
  // similar to the above, only this is what browsers would usually do even for 0
  instant: 10,

  // the lower and upper bounds for a user to not notice delay
  flash: 100,
  fast: 400,

  // delay timeout specifically for fast onBlur delays.
  blur: 200,

  // a split second, used in some setState timeouts
  split: 500,

  // amount of time to keep user's attention
  attention: SECOND,

  // default amount of time to hide some less important UI elements
  autohide: 3 * SECOND,

  // amounts of time to hide some less important UI elements
  autohide1: 3 * SECOND,
  autohide2: 5 * SECOND,

  // after 10 seconds user usually loses interest
  disinterest: 10 * SECOND,

  // something that will linger for a while, beyond disinterest
  linger: 15 * SECOND,

  // time to show upload complete state before redirecting to Slick Email
  uploadCompleteView: 2.5 * SECOND,

  backendTimeout: 30 * SECOND,
});

// noinspection JSUnusedGlobalSymbols
export default DELAY;
